import { render, staticRenderFns } from "./FlagMarketingEmpty.vue?vue&type=template&id=338ff5f4&scoped=true&"
import script from "./FlagMarketingEmpty.vue?vue&type=script&lang=js&"
export * from "./FlagMarketingEmpty.vue?vue&type=script&lang=js&"
import style0 from "./FlagMarketingEmpty.vue?vue&type=style&index=0&id=338ff5f4&lang=scss&scoped=true&"
import style1 from "./FlagMarketingEmpty.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ff5f4",
  null
  
)

export default component.exports